export default "__VITE_ASSET__CgsuU$Nx__"